import { NavLink } from "react-router-dom";

import { ACESSOS } from "../../../Routes/Acessos";
import React, { useState } from "react";
import { ClickAwayListener } from "@material-ui/core";
import { useUserInfor } from "../../../Context/User/";
import { SubNavGestaoRegua } from "./subnavs/GestaoRegua";
import {
    mostrarDropdownDeTelas,
    mostrarNavDeTela,
} from "../../../Validations/UsuarioTela";

export default function AutomacaoTab() {
    const { UserInfor } = useUserInfor();
    //menu-item-open-dropdown menu-item-hover
    const [showDropdownRegua, setshowDropdownRegua] = useState("");

    return (
        <div className="tab-pane py-5 p-lg-0 show active" id="AutomacaoTab">
            <div
                id="kt_header_menu"
                className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
            >
                <ul className="menu-nav">
                    <li className="menu-item">
                        <NavLink
                            to={ACESSOS.AUTOMACAO.TELAS.AUDIENCIA.DS_PATH}
                            exact
                            activeClassName="active"
                            className="menu-link"
                        >
                            <span className="menu-text">
                                Gestão de Audiência
                            </span>
                        </NavLink>
                    </li>
                    {
                        //telas do dropdown
                        mostrarDropdownDeTelas(
                            [
                                ACESSOS.AUTOMACAO.TELAS.REGUA.CONFIG.ID_TELA,
                                ACESSOS.AUTOMACAO.TELAS.REGUA.GESTAO.ID_TELA,
                            ],
                            UserInfor.TELAS
                        ) && (
                            <ClickAwayListener
                                mouseEvent="onMouseDown"
                                touchEvent="onTouchEnd"
                                onClickAway={() => {
                                    setshowDropdownRegua("");
                                }}
                            >
                                <li
                                    className={`menu-item menu-item-submenu ${showDropdownRegua}`}
                                >
                                    <span
                                        className="menu-link menu-toggle"
                                        onClick={() => {
                                            if (
                                                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                                    navigator.userAgent
                                                )
                                            ) {
                                                if (
                                                    document.getElementsByClassName(
                                                        "menu-item-open menu-item-open-dropdown menu-item-hover"
                                                    ).length > 0
                                                )
                                                    setshowDropdownRegua("");
                                                else
                                                    setshowDropdownRegua(
                                                        "menu-item-open menu-item-open-dropdown menu-item-hover"
                                                    );
                                            } else {
                                                if (
                                                    document.getElementsByClassName(
                                                        "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                                    ).length > 0
                                                )
                                                    setshowDropdownRegua("");
                                                else
                                                    setshowDropdownRegua(
                                                        "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                                    );
                                            }
                                        }}
                                    >
                                        <span className="menu-text">Régua</span>
                                        <span className="menu-desc"></span>
                                        <i className="menu-arrow"></i>
                                    </span>

                                    <SubNavGestaoRegua />
                                </li>
                            </ClickAwayListener>
                        )
                    }
                    {mostrarNavDeTela(
                        ACESSOS.AUTOMACAO.TELAS.FORMULARIOS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.AUTOMACAO.TELAS.FORMULARIOS.DS_PATH}
                                exact
                                activeClassName="menu-link-active"
                                className="menu-link"
                            >
                                <span className="menu-text">Formulários</span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.AUTOMACAO.TELAS.COMUNICADOS_AUDIENCIA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={
                                    ACESSOS.AUTOMACAO.TELAS
                                        .COMUNICADOS_AUDIENCIA.DS_PATH
                                }
                                exact
                                activeClassName="menu-link-active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Agendamentos de Comunicado
                                </span>
                            </NavLink>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
